import { Select } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

function SelectInput({ name, ...otherProps }) {
    const [val, setVal] = useState(otherProps.defaultValue ?? '')

    // Resync when a caller recomputes defaultValue programmatically (e.g. the
    // purchase-bill entity change recompute) — otherwise this only seeds once
    // on mount and silently ignores later defaultValue changes.
    useEffect(() => {
        setVal(otherProps.defaultValue ?? '')
    }, [otherProps.defaultValue])

    return (
        <>
            <Select
                {...otherProps}
                value={val ?? undefined}
                onChange={(v) => {
                    setVal(v)
                    if (otherProps.onChange) {
                        otherProps.onChange(v)
                    }
                }}
            />
            <input type="hidden" name={name} value={val} />
        </>
    );
}

SelectInput.propTypes = {
    name: PropTypes.string.isRequired
}

export default SelectInput;
